import React from 'react';
import { useChatWithUserPathname } from '../../../../../data/hooks/chat/useChatWithUserPathname';
import UserAvatar from '../../../../elements/icons/UserAvatar';
import Link from '../../../../elements/Link';
import UserName from '../../../../elements/UserName';
import LoadChatSessions from '../../../../loaders/LoadChatSessions';
import styles from './MeetingPeer.module.scss';
import { useEventChatEnabled } from '../../../../../data/hooks/eventFeatures/useEventChatEnabled';

function MeetingPeer(props) {
    const { user } = props,
        href = ['.', 'participants', user.id, '-'].join('/'),
        hrefChat = useChatWithUserPathname(user.id),
        isChatEnabled = useEventChatEnabled();

    return (
        <LoadChatSessions>
            <div className={styles.MeetingPeer}>
                <Link href={href} className={styles.link}>
                    <UserAvatar className={styles.avatar} user={user} size={60} />
                </Link>
                <Link href={href} className={[styles.link, styles.user].join(' ')}>
                    <div className={styles.name}>
                        <UserName user={user} />
                    </div>
                    <div className={styles.position}>{user.position}</div>
                    <div className={styles.company}>{user.company}</div>
                </Link>
                {isChatEnabled && user.pref_available_for_chat ? <Link href={hrefChat} type="button" className={styles.chat} /> : null}
            </div>
        </LoadChatSessions>
    );
}

export default MeetingPeer;
